var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfRatio = function SvgPdfRatio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.914 16.5V9H6V7.5h3.414v9zm3.817 0V15h1.5v1.5zm4.769 0V9h-1.904V7.5H18v9zm-4.77-3.75v-1.5h1.5v1.5z"
  })));
};
export default SvgPdfRatio;